import { Injectable } from '@angular/core';
import { EmissionService } from 'services/emission.service';
import { Constants } from 'config/constants';


@Injectable()
export class EventsTravelService {
    private category = Constants.categories.events.travel;

    private travelList = {
        travel: {
            emission: 0,
            emissionTrees: 0,
            DollarAmt: 0,
            DollarAmtMonthly: 0
        },
        hotel: {
            emission: 0,
            emissionTrees: 0,
            DollarAmt: 0,
            DollarAmtMonthly: 0
        }
    };

    constructor(private emissionService: EmissionService) {
    }

    addToList(model: {category, emission: {emission, emissionTrees, DollarAmt, DollarAmtMonthly}}) {
        this.travelList[model.category] = model.emission;
        this.sendEmissionToDashboard();
    }

    getTotalEmission(): void {
        // isTravelListFull is full when 2 steps are filled out
        let isTravelListFull = (this.travelList.travel.emission > 0) && (this.travelList.hotel.emission > 0);

        if (isTravelListFull) {
            this.getTotalPrice();
        } else {
            this.sendPreparedDataToDashboard(this.calculateSum());
        }
    }

    getTotalPrice(): void {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        emission = this.calculateSum().emission;

        this.emissionService.getTotalPrice(emission).subscribe(
            response => {
                let input = response[0];
                emissionTrees = input.emissionTrees;
                DollarAmt = input.DollarAmt;
                DollarAmtMonthly = input.DollarAmtMonthly;

                this.sendPreparedDataToDashboard({
                    emission,
                    emissionTrees,
                    DollarAmt,
                    DollarAmtMonthly
                });
            }
        );
    }

    calculateSum(): {emission, emissionTrees, DollarAmt, DollarAmtMonthly} {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        for (let key in this.travelList) {
            if (this.travelList.hasOwnProperty(key)) {
                emission += this.travelList[key].emission;
                emissionTrees += this.travelList[key].emissionTrees;
                DollarAmt += this.travelList[key].DollarAmt;
                DollarAmtMonthly += this.travelList[key].DollarAmtMonthly;
            }

        }

        return {
            emission,
            emissionTrees,
            DollarAmt,
            DollarAmtMonthly
        };
    };

    sendPreparedDataToDashboard(emission: {emission, emissionTrees, DollarAmt, DollarAmtMonthly}): void {
        this.emissionService.setEmission({
            category: this.category,
            emission: emission
        });
    }

    sendEmissionToDashboard(): void {
        this.getTotalEmission();
    }

    public cleanList(): void {
        this.travelList = {
            travel: {
                emission: 0,
                emissionTrees: 0,
                DollarAmt: 0,
                DollarAmtMonthly: 0
            },
            hotel: {
                emission: 0,
                emissionTrees: 0,
                DollarAmt: 0,
                DollarAmtMonthly: 0
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/calculator-items/events-travel.service.ts